module.exports = __webpack_public_path__ + "img/motorcycle-blue.df73486d.svg";